import type { Phone } from '../types'
import { statusConfig } from '../config/statusConfig'
import { DASH } from '../lib/metricFormat'
import { ownerLabel } from '../lib/ownerLabel'
import { BatteryCell, SignalCell, SimCell, UptimeCell } from './MetricCell'
import { PermissionsCell } from './PermissionsCell'
import { PhoneActions, type PhoneActionsCallbacks } from './PhoneActions'

interface PhoneRowProps extends PhoneActionsCallbacks {
  phone: Phone
}

export function PhoneRow({ phone, ...actions }: PhoneRowProps) {
  const sc = statusConfig[phone.status]
  const inactiveClass = phone.isActive ? '' : 'opacity-50'
  const owner = ownerLabel(phone)

  return (
    <tr
      className={`border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-900/40 ${inactiveClass}`}
      data-testid={`phone-row-${phone.id}`}
    >
      <td className="py-2 pl-3 pr-2 align-middle">
        <span
          className={`inline-block w-2.5 h-2.5 rounded-full ${sc.dot}`}
          title={sc.label}
        />
      </td>
      <td className="py-2 px-2 align-middle">
        <div className="font-medium text-gray-900 dark:text-gray-100 truncate">{phone.name}</div>
        <div className="text-xs text-gray-500 dark:text-gray-400 truncate">{phone.sim}</div>
      </td>
      <td className="py-2 px-2 align-middle">
        <SimCell phone={phone} />
      </td>
      <td className="py-2 px-2 align-middle">
        <SignalCell phone={phone} />
      </td>
      <td className="py-2 px-2 align-middle">
        <PermissionsCell phone={phone} />
      </td>
      <td className="py-2 px-2 align-middle">
        <BatteryCell phone={phone} />
      </td>
      <td className="py-2 px-2 align-middle text-xs text-gray-600 dark:text-gray-400 truncate">
        {owner}
      </td>
      <td className="py-2 px-2 align-middle">
        <UptimeCell phone={phone} />
      </td>
      <td className="py-2 px-2 align-middle text-xs text-gray-600 dark:text-gray-400">
        {phone.metrics?.phoneModel ?? DASH}
      </td>
      <td className="py-2 px-2 align-middle text-xs text-gray-600 dark:text-gray-400">
        {phone.metrics?.osVersion ? `Android ${phone.metrics.osVersion}` : DASH}
      </td>
      <td className="py-2 px-2 align-middle text-xs text-gray-600 dark:text-gray-400">
        {phone.metrics?.appVersion ?? DASH}
      </td>
      <td className="py-2 pl-2 pr-3 align-middle">
        {/* justify-end keeps icons flush to the right edge of the cell even
            when the column happens to be wider than its content. */}
        <div className="flex justify-end">
          <PhoneActions phone={phone} {...actions} />
        </div>
      </td>
    </tr>
  )
}
